  //-----------------------
  // React basic Components
  //-----------------------
  import React                                               from "react";
  import PropTypes                                           from "prop-types";
//import { NavLink }                                         from "react-router-dom";
  import { connect }                                         from "react-redux";
  //-----------------------------
  // @material-ui/core components
  //-----------------------------
  import withStyles                                          from "@material-ui/core/styles/withStyles";
  import Button                                              from '@material-ui/core/Button';
//import IconButton                                          from '@material-ui/core/IconButton';
//import TextField                                           from '@material-ui/core/TextField';
  import CircularProgress                                    from "@material-ui/core/CircularProgress";
//import AccountCircleIcon                                   from "@material-ui/icons/AccountCircle";
  import Dialog                                              from '@material-ui/core/Dialog';
  import DialogActions                                       from '@material-ui/core/DialogActions';
  import DialogContent                                       from '@material-ui/core/DialogContent';
  import DialogContentText                                   from '@material-ui/core/DialogContentText';
  import DialogTitle                                         from '@material-ui/core/DialogTitle';
  import Slide                                               from '@material-ui/core/Slide';
//import FormControlLabel                                    from '@material-ui/core/FormControlLabel';
//import InputLabel                                          from '@material-ui/core/InputLabel';
//import MenuItem                                            from '@material-ui/core/MenuItem';
//import FormHelperText                                      from '@material-ui/core/FormHelperText';
//import FormControl                                         from '@material-ui/core/FormControl';
//import Select                                              from '@material-ui/core/Select';

  import List                                                from '@material-ui/core/List';
  import ListItem                                            from '@material-ui/core/ListItem';
//import ListItemText                                        from '@material-ui/core/ListItemText';
//import ListItemIcon                                        from '@material-ui/core/ListItemIcon';
  import Divider                                             from '@material-ui/core/Divider';
//import ArrowForwardIosIcon                                 from '@material-ui/icons/ArrowForwardIos';
//import ArrowRightIcon                                      from '@material-ui/icons/ArrowRight';
  //----------------
  // core components
  //----------------
  import GridContainer                                       from "components/Grid/GridContainer.jsx";
  import GridItem                                            from "components/Grid/GridItem.jsx";
  import CustomButton                                        from "components/CustomButtons/Button.jsx";
//import CustomInput                                         from "components/CustomInput/CustomInput.jsx";
//import CustomDropdown                                      from "components/CustomDropdown/CustomDropdown.jsx";
  //--------------------
  // 3rd party libraries
  //--------------------
//import Cookies                                             from 'js-cookie';
  //------------
  // WebServices
  //------------
  import { history }                                         from "../../_helpers";
  import { api }                                             from "../../_constants";
  import { wu_StaticDataService }                            from "../../_services";
  import { wu_Utilities }                                    from "../../_services";
  import { wu_HistoryService }                               from "../../_services";
//import { wu_CountriesStatesCitiesService }                 from "../../_services";
  import { wu_CurrenciesService }                            from "../../_services";
  //------
  // Style
  //------
  import HistoryListStyle                                    from "./HistoryListStyle.jsx";
  //-------
  // images
  //-------
  import logo                                                from "assets/img/wu/WU_CONTENT_main_symbol_left.svg";
  //----------
  // variables
  //----------
  const filename = "HistoryList ";
  const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });

class HistoryList extends React.Component {
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Basic Methods-------------------------------------
  //----------------------------------------------------------------------------------------------------
  constructor(props) {
    let methName = filename+"constructor ";
    if(api.print_logs){console.log(methName+props);}

    super(props);
    this.state = {
      dialog_msg                                           : "",
      dialog_isOpen                                        : false,

      viewPleaseWait_hidden                                : true,

      actions_isOpen                                       : false,
      isTransactionCompleted                               : true,
      isTransactionPending                                 : true,
      isTransactionCanceled                                : true,

      parserObject_transhistory                            : [],
    };
    //------------
    //translations
    //------------
    this.texts_gr = wu_StaticDataService.wu_getLocales_gr({});
    this.texts_en = wu_StaticDataService.wu_getLocales_en({});
    //--------
    //bindings
    //--------
    this.verifyGenericItem                                 = this.verifyGenericItem.bind(this);
    this.dialog_handleClose                                = this.dialog_handleClose.bind(this);
    this.startSpinners                                     = this.startSpinners.bind(this);
    this.stopSpinners                                      = this.stopSpinners.bind(this);

    this.handleListItemClick_details                       = this.handleListItemClick_details.bind(this);
    this.handleListItemClick_actions                       = this.handleListItemClick_actions.bind(this);

    this.handleListItemClick_repeatTrans                   = this.handleListItemClick_repeatTrans.bind(this);
    this.handleListItemClick_cancelTrans                   = this.handleListItemClick_cancelTrans.bind(this);
    this.handleListItemClick_changeTrans                   = this.handleListItemClick_changeTrans.bind(this);
    this.handleListItemClick_refundTrans                   = this.handleListItemClick_refundTrans.bind(this);
    this.handleListItemClick_cancelAction                  = this.handleListItemClick_cancelAction.bind(this);

    this.get_date_FromObj                                  = this.get_date_FromObj.bind(this);
    this.getTransferMethodFromObj                          = this.getTransferMethodFromObj.bind(this);
    this.get_fullName_FromObj                              = this.get_fullName_FromObj.bind(this);
    this.get_amount_FromObj                                = this.get_amount_FromObj.bind(this);
    this.get_countryName_FromObj                           = this.get_countryName_FromObj.bind(this);

    //[goBack]
    this.goBack                                                       = this.goBack.bind(this);
  }
  //----------------------------------------------------------------------------------------------------
  componentWillMount() {
    let methName = filename+"componentWillMount ";
    if(api.print_logs){console.log(methName);}

    localStorage.setItem("prev_view", localStorage.getItem("curr_view"));
    localStorage.setItem("curr_view", filename);

    if(localStorage.getItem("lang")!=='el' && localStorage.getItem("lang")!=='en'){ localStorage.setItem("lang","el"); }

    //++++++++++++++++++++++
    //webapp session timeout
    //++++++++++++++++++++++
    if(wu_Utilities.checkIfUserIsLoggedIn()){
      wu_Utilities.update_uilatstats();
      if(!wu_Utilities.check_uilatstats(api.uilatstats_inactivity_mins)){ wu_Utilities.LogoutUserFromApp(filename); history.push(wu_Utilities.getNavigationURLs("LoginPage")); return; }
    }
    if(!wu_Utilities.checkIfUserIsLoggedIn()){
      wu_Utilities.LogoutUserFromApp(filename); history.push(wu_Utilities.getNavigationURLs("LoginPage")); return;
    }
    //---------------------
    //newCustomer filtering--load Contoller---Exclude(LIGHT,BP)
    //---------------------
    if(api.new_registration_enabled){
      let parserObject_validatecustomer = {};
      try{ parserObject_validatecustomer = JSON.parse(localStorage.getItem("parserObject_validatecustomer"));}catch(err){console.log(methName+'err='+err);}
      let customerLevel = wu_Utilities.textDecisions_customerLevel(api.print_logs,parserObject_validatecustomer);
      if(customerLevel==="LIGHT"){ try {localStorage.setItem("newRegistrationFlow","newCustomer");   }catch(err){;} history.push(wu_Utilities.getNavigationURLs("RegisterLightInfo")); return; }
      if(customerLevel==="BP")   { try {localStorage.setItem("newRegistrationFlow","upgradeAccount");}catch(err){;} history.push(wu_Utilities.getNavigationURLs("RegisterLightInfo")); return; }
    }

    //localStorage.setItem("accessToken", "bad717b8-e102-408f-97b0-9f8aefed26d2");
    //let shouldForceRefreshAccessToken = wu_Utilities.shouldForceRefreshAccessToken();
    //if(api.print_logs){console.log('cookie='+Cookies.get('testCookie'));}

    //-------------
    //Do some reset
    //-------------
    try { localStorage.setItem("parserObject_omtregistrationTriggerOTP_req", ""); } catch(err){;}
    try { localStorage.setItem("parserObject_transhistorydetail_unique",""); } catch(err){;}
    try { localStorage.setItem("RegisterLight1".trim(), "");  } catch(err){;}

    //-------------
    //getCurrencies---CACHED
    //-------------
    let retrieveWSData_getCurrencies = wu_CurrenciesService.wu_should_getCurrencies();
    if(api.print_logs){console.log("retrieveWSData_getCurrencies="+retrieveWSData_getCurrencies);}
    if(retrieveWSData_getCurrencies){
      wu_CurrenciesService
      .wu_getCurrencies({})
      .then(res => {
        if(localStorage.getItem("curr_view").trim()!=="HistoryList"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
        this.setState({ "parserObject_getCurrencies_ALL" : res.countries }); //YES! the subitem is countries!!!
      })
      .catch(err => {
        console.log(methName+"err="+JSON.stringify(err));
      });
    }
    else{
      try{
        let res = JSON.parse(localStorage.getItem("currencies"));
        let parserObject_getCountries4Picker= [];
        for(let i=0; i<res.countries.length; ++i){ parserObject_getCountries4Picker.push(res.countries[i]["descr_el"]); }
        this.setState({ "parserObject_getCurrencies_ALL" : res.countries }); //YES! the subitem is countries!!!
      }catch(err){
        console.log('err='+err);
      }
    }



    this.setState({ "parserObject_transhistory": [] });
    this.startSpinners();
    setTimeout(function() { //Start the timer
      //-----------------
      //wu_HistoryService
      //-----------------
      wu_HistoryService
      .wu_transhistory({})
      .then(res => {
        if(localStorage.getItem("curr_view").trim()!=="HistoryList"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
        this.setState({ "parserObject_transhistory": res.transactions });
        this.stopSpinners();
      })
      .catch(err => {
        this.stopSpinners();
        console.log(methName+"err="+JSON.stringify(err));
        if(err && err.returnCode && err.returnCode!==0){ if(err.returnCode===100){wu_Utilities.LogoutUserFromApp(filename);history.push(wu_Utilities.getNavigationURLs("LoginPage"));} this.dialog_handleOpen(err.returnText); }
        else                                           { this.dialog_handleOpen(this.NSInforString("networkerror")); }
      });
    }.bind(this), 500);
  }
  //----------------------------------------------------------------------------------------------------
  componentDidMount() {
    let methName = filename+"componentDidMount ";
    if(api.print_logs){console.log(methName);}
  }
  //----------------------------------------------------------------------------------------------------
  componentWillUnmount() {
    let methName = filename+"componentWillUnmount ";
    if(api.print_logs){console.log(methName);}
  }
  //----------------------------------------------------------------------------------------------------
  render() {
    let methName = filename+"render ";
    if(api.print_logs){console.log(methName);}

    const classes = this.props.classes;

    return (
      <div className={classes.container}>
        <GridContainer justify="center">
          <GridItem xs={12} sm={6} md={6}>

            <GridContainer justify="center">
              <GridItem xs={2} sm={2} md={1}>
                <div style={{ marginTop:20,marginBottom:10, textAlign:"left" }}>
                  {/* ----------[goBack]------------ */}
                  {/* <Button style={{ backgroundColor:"#FFDD00" }} onClick={this.goBack}><KeyboardBackspaceIcon/></Button> */}
                </div>
              </GridItem>
              <GridItem xs={10} sm={10} md={11}>
                <div style={{ marginTop: 25 }}>
                  <div className={classes.labelHeader}>{this.NSInforString("History_title")}</div>
                  <div className={classes.logo}><img src={logo} alt="logo" /></div>
                </div>
              </GridItem>
            </GridContainer>

            {/* ------------------------- */}
            {/* ----------[SPINNERS]----- */}
            {/* ------------------------- */}
            {this.state.viewPleaseWait_hidden === true ? ( "" ) : (
              <GridContainer justify="center">
                <GridItem xs={3} sm={3} md={3}></GridItem>
                <GridItem xs={6} sm={6} md={6}>
                  <div className={classes.pleaseWait}><CircularProgress/><span>&nbsp;{this.NSInforString("please_wait")}</span></div>
                </GridItem>
                <GridItem xs={3} sm={3} md={3}></GridItem>
              </GridContainer>
            )}

            <div style={{marginBottom:20}}>
              <List component="nav" aria-label="main mailbox folders">
                {this.state.parserObject_transhistory.map(e => (
                  <React.Fragment key={"fragmentId_"+e.trans_id}>
                    <ListItem>
                      <GridContainer justify="center">
                        <GridItem xs={6} sm={6} md={6}><div className={classes.listItem_date}>{this.get_date_FromObj(e)}</div></GridItem>
                        <GridItem xs={6} sm={6} md={6}><div style={{color:this.get_statusColor_FromObj(e) }} className={classes.listItem_TM}>{this.getStatusFromObj(e)}</div></GridItem>

                        <GridItem xs={6} sm={6} md={6}><div className={classes.listItem_fullName}>{this.get_fullName_FromObj(e)}</div></GridItem>
                        <GridItem xs={6} sm={6} md={6}><div style={{textAlign:"right"}}><span className={classes.listItem_amount}>{this.get_amount_FromObj(e)}</span> <span className={classes.listItem_currency}>EUR</span></div></GridItem>

                        <GridItem xs={6} sm={6} md={6}>{this.get_countryName_FromObj(e)}</GridItem>
                        <GridItem xs={6} sm={6} md={6}><div style={{textAlign:"right"}}><Button className={classes.listItembutton} id={e.trans_id} value={e.trans_id} onClick={(event) => this.handleListItemClick_details(e.trans_id)} color="primary">{this.NSInforString("History_details_btn")}</Button> | <Button className={classes.listItembutton} id={e.trans_id} value={e.trans_id} onClick={(event) => this.handleListItemClick_actions(e.trans_id)} color="primary">{this.NSInforString("History_actions_btn")}</Button></div></GridItem>
                      </GridContainer>
                    </ListItem>
                    <Divider />
                  </React.Fragment>
                ))}
              </List>
            </div>

            {this.state.viewPleaseWait_hidden === true && this.state.parserObject_transhistory.length === 0 ? (
              <div style={{marginTop:20}}>
                <GridContainer justify="center">
                  <GridItem xs={12} sm={12} md={12}><div className={classes.History_nohistory_lbl1}>{this.NSInforString("History_nohistory_lbl1")}</div></GridItem>
                </GridContainer>
              </div>
            ) : (
              ""
            )}
            {this.state.viewPleaseWait_hidden === true && this.state.parserObject_transhistory.length === 0 ? (
              <div style={{marginTop:20}}>
                <GridContainer justify="center">
                  <GridItem xs={12} sm={12} md={12}><div className={classes.History_nohistory_lbl2}>{this.NSInforString("History_nohistory_lbl2")}</div></GridItem>
                </GridContainer>
              </div>
            ) : (
              ""
            )}

            {api.backButtonAtBottom === true ? (
              <GridContainer justify="center">
                <GridItem xs={10} sm={10} md={10}>
                  <div className={classes.textCenter}>
                    <CustomButton
                      disabled={false}
                      className={classes.backButton}
                      color="rose"
                      onClick={this.goBack}>
                      {this.NSInforString("BillsPaymentReview_btn_prev")}
                    </CustomButton>
                  </div>
                </GridItem>
              </GridContainer>
            ) : ( "" ) }

          </GridItem>
        </GridContainer>
        {/* ------------------------- */}
        {/* ----------[POPUP]-------- */}
        {/* ------------------------- */}
        <div>
          <Dialog
            open={this.state.dialog_isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.dialog_handleClose}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title">{api.popup_tile}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">{this.state.dialog_msg}</DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button className={classes.popupOkButton} color="default" onClick={this.dialog_handleClose}>OK</Button>
            </DialogActions>
          </Dialog>
        </div>
        {/* ------------------------- */}
        {/* ----------[ACTIONS]------ */}
        {/* ------------------------- */}
        <div>
          <Dialog
            open={this.state.actions_isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.dialog_handleClose}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
          >
            {/* ----------[show PENDING=Y]------ */}
            {this.state.isTransactionCompleted === true ? (
              <List component="nav" aria-label="main mailbox folders" style={{"minWidth":"250px"}}>
                <ListItem>
                  <GridContainer justify="center">
                    <GridItem xs={12} sm={12} md={12}>
                      <div className={classes.popup_label_header}>{this.NSInforString("History2_btn_selectAction")}</div>
                    </GridItem>
                  </GridContainer>
                </ListItem>
                <Divider />

                <ListItem onClick={this.handleListItemClick_changeTrans} button>
                  <GridContainer justify="center">
                    <GridItem xs={12} sm={12} md={12}>
                      <div className={classes.popup_label_normal_action}>{this.NSInforString("History2_btn_changeTrans")}</div>
                    </GridItem>
                  </GridContainer>
                </ListItem>
                <Divider />

                <ListItem onClick={this.handleListItemClick_refundTrans} button>
                  <GridContainer justify="center">
                    <GridItem xs={12} sm={12} md={12}>
                    <div className={classes.popup_label_normal_action}>{this.NSInforString("History2_btn_refundTrans")}</div>
                    </GridItem>
                  </GridContainer>
                </ListItem>
                <Divider />

                <ListItem onClick={this.handleListItemClick_repeatTrans} button>
                  <GridContainer justify="center">
                    <GridItem xs={12} sm={12} md={12}>
                      <div className={classes.popup_label_normal_action}>{this.NSInforString("History2_btn_repeatTrans")}</div>
                    </GridItem>
                  </GridContainer>
                </ListItem>
                <Divider />

                <ListItem onClick={this.handleListItemClick_cancelAction} button>
                  <GridContainer justify="center">
                    <GridItem xs={12} sm={12} md={12}>
                      <div className={classes.popup_label_close}>{this.NSInforString("History2_btn_cancelAction")}</div>
                    </GridItem>
                  </GridContainer>
                </ListItem>
              </List>
            ) : ( "" ) }
            {/* ----------[show CANCELED=Y]------ */}
            {this.state.isTransactionCanceled === true ? (
              <List component="nav" aria-label="main mailbox folders" style={{"min-width":"250px"}}>
                <ListItem>
                  <GridContainer justify="center">
                    <GridItem xs={12} sm={12} md={12}>
                      <div className={classes.popup_label_header}>{this.NSInforString("History2_btn_selectAction")}</div>
                    </GridItem>
                  </GridContainer>
                </ListItem>
                <Divider />

                <ListItem onClick={this.handleListItemClick_repeatTrans} button>
                  <GridContainer justify="center">
                    <GridItem xs={12} sm={12} md={12}>
                      <div className={classes.popup_label_normal_action}>{this.NSInforString("History2_btn_repeatTrans")}</div>
                    </GridItem>
                  </GridContainer>
                </ListItem>
                <Divider />

                <ListItem onClick={this.handleListItemClick_cancelAction} button>
                  <GridContainer justify="center">
                    <GridItem xs={12} sm={12} md={12}>
                    <div className={classes.popup_label_close}>{this.NSInforString("History2_btn_cancelAction")}</div>
                    </GridItem>
                  </GridContainer>
                </ListItem>
              </List>
            ):( "" ) }
            {/* ----------[show PENDING=Y]------ */}
            {this.state.isTransactionPending === true ? (
              <List component="nav" aria-label="main mailbox folders" style={{"min-width":"250px"}}>
                <ListItem>
                  <GridContainer justify="center">
                    <GridItem xs={12} sm={12} md={12}>
                      <div className={classes.popup_label_header}>{this.NSInforString("History2_btn_selectAction")}</div>
                    </GridItem>
                  </GridContainer>
                </ListItem>
                <Divider />

                <ListItem onClick={this.handleListItemClick_cancelTrans} button>
                  <GridContainer justify="center">
                    <GridItem xs={12} sm={12} md={12}>
                      <div className={classes.popup_label_cancel_action}>{this.NSInforString("History2_btn_cancelTrans")}</div>
                    </GridItem>
                  </GridContainer>
                </ListItem>
                <Divider />

                <ListItem onClick={this.handleListItemClick_repeatTrans} button>
                  <GridContainer justify="center">
                    <GridItem xs={12} sm={12} md={12}>
                      <div className={classes.popup_label_normal_action}>{this.NSInforString("History2_btn_repeatTrans")}</div>
                    </GridItem>
                  </GridContainer>
                </ListItem>
                <Divider />

                <ListItem onClick={this.handleListItemClick_cancelAction} button>
                  <GridContainer justify="center">
                    <GridItem xs={12} sm={12} md={12}>
                    <div className={classes.popup_label_close}>{this.NSInforString("History2_btn_cancelAction")}</div>
                    </GridItem>
                  </GridContainer>
                </ListItem>
              </List>
            ):( "" ) }
          </Dialog>
        </div>
      </div>
    );
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------ListItem Listeners--------------------------------
  //----------------------------------------------------------------------------------------------------
  handleListItemClick_repeatTrans(event){
    let methName = filename+"handleListItemClick_repeatTrans ";
    if(api.print_logs){console.log(methName);}

    //++++++++++++++++++++++
    //webapp session timeout
    //++++++++++++++++++++++
    if(wu_Utilities.checkIfUserIsLoggedIn()){
      wu_Utilities.update_uilatstats();
      if(!wu_Utilities.check_uilatstats(api.uilatstats_inactivity_mins)){ wu_Utilities.LogoutUserFromApp(filename); history.push(wu_Utilities.getNavigationURLs("LoginPage")); return; }
    }

    let aRow = {};
    try { aRow = JSON.parse(localStorage.getItem("parserObject_transhistorydetail")); }catch(err){;}
    try { localStorage.setItem("parserObject_transhistorydetail_unique",JSON.stringify(aRow)); } catch(err){;}
    //+++++++++++++++
    //TransferOnline1
    //+++++++++++++++
    history.push(wu_Utilities.getNavigationURLs("TransferOnline1"));
  }
  //----------------------------------------------------------------------------------------------------
  handleListItemClick_cancelTrans(event){
    let methName = filename+"handleListItemClick_cancelTrans ";
    if(api.print_logs){console.log(methName);}

    //++++++++++++++++++++++
    //webapp session timeout
    //++++++++++++++++++++++
    if(wu_Utilities.checkIfUserIsLoggedIn()){
      wu_Utilities.update_uilatstats();
      if(!wu_Utilities.check_uilatstats(api.uilatstats_inactivity_mins)){ wu_Utilities.LogoutUserFromApp(filename); history.push(wu_Utilities.getNavigationURLs("LoginPage")); return; }
    }

    let aRow = {};
    try { aRow = JSON.parse(localStorage.getItem("parserObject_transhistorydetail")); }catch(err){;}
    let transactionId = "";
    try {transactionId = aRow["trans_id"]; }catch(err){;}
    if(transactionId === null || (typeof transactionId === "undefined")){transactionId= ""; }

    this.setState({
      "actions_isOpen" : false
    });

    //this.startSpinners();
    setTimeout(function() { //Start the timer
      //--------------------
      //wu_cancelTransaction
      //--------------------
      wu_HistoryService
      .wu_cancelTransaction({transactionId:transactionId})
      .then(res => {
        if(localStorage.getItem("curr_view").trim()!=="HistoryList"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
        //-----------------
        //wu_HistoryService
        //-----------------
        wu_HistoryService
        .wu_transhistory({})
        .then(res => {
          if(localStorage.getItem("curr_view").trim()!=="HistoryList"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
          this.setState({ "parserObject_transhistory": res.transactions });
        })
        .catch(err => {
          //this.stopSpinners();
          console.log(methName+"err="+JSON.stringify(err));
          if(err && err.returnCode && err.returnCode!==0){ if(err.returnCode===100){wu_Utilities.LogoutUserFromApp(filename);history.push(wu_Utilities.getNavigationURLs("LoginPage"));} this.dialog_handleOpen(err.returnText); }
          else                                           { this.dialog_handleOpen(this.NSInforString("networkerror")); }
        });

      })
      .catch(err => {
        //this.stopSpinners();
        console.log(methName+"err="+JSON.stringify(err));
        if(err && err.returnCode && err.returnCode!==0){ if(err.returnCode===100){wu_Utilities.LogoutUserFromApp(filename);history.push(wu_Utilities.getNavigationURLs("LoginPage"));} this.dialog_handleOpen(err.returnText); }
        else                                           { this.dialog_handleOpen(this.NSInforString("networkerror")); }
      });
    }.bind(this), 500);
  }
  //----------------------------------------------------------------------------------------------------
  handleListItemClick_refundTrans(event){
    let methName = filename+"handleListItemClick_refundTrans ";
    if(api.print_logs){console.log(methName);}

    //++++++++++++++++++++++
    //webapp session timeout
    //++++++++++++++++++++++
    if(wu_Utilities.checkIfUserIsLoggedIn()){
      wu_Utilities.update_uilatstats();
      if(!wu_Utilities.check_uilatstats(api.uilatstats_inactivity_mins)){ wu_Utilities.LogoutUserFromApp(filename); history.push(wu_Utilities.getNavigationURLs("LoginPage")); return; }
    }

    //+++++++++++++
    //HistoryRefund
    //+++++++++++++
    history.push(wu_Utilities.getNavigationURLs("HistoryRefund"));
  }
  //----------------------------------------------------------------------------------------------------
  handleListItemClick_changeTrans(event){
    let methName = filename+"handleListItemClick_changeTrans ";
    if(api.print_logs){console.log(methName);}

    //++++++++++++++++++++++
    //webapp session timeout
    //++++++++++++++++++++++
    if(wu_Utilities.checkIfUserIsLoggedIn()){
      wu_Utilities.update_uilatstats();
      if(!wu_Utilities.check_uilatstats(api.uilatstats_inactivity_mins)){ wu_Utilities.LogoutUserFromApp(filename); history.push(wu_Utilities.getNavigationURLs("LoginPage")); return; }
    }

    //+++++++++++++
    //HistoryChange
    //+++++++++++++
    history.push(wu_Utilities.getNavigationURLs("HistoryChange"));
  }
  //----------------------------------------------------------------------------------------------------
  handleListItemClick_cancelAction(event){
    let methName = filename+"handleListItemClick_cancelAction ";
    if(api.print_logs){console.log(methName);}

    this.setState({
      "actions_isOpen" : false
    });
  }
  //----------------------------------------------------------------------------------------------------
  //----------------------------------------------------------------------------------------------------
  handleListItemClick_details(event_trans_id){
    let methName = filename+"handleListItemClick_details ";
    if(api.print_logs){console.log(methName+event_trans_id);}

    //++++++++++++++++++++++
    //webapp session timeout
    //++++++++++++++++++++++
    if(wu_Utilities.checkIfUserIsLoggedIn()){
      wu_Utilities.update_uilatstats();
      if(!wu_Utilities.check_uilatstats(api.uilatstats_inactivity_mins)){ wu_Utilities.LogoutUserFromApp(filename); history.push(wu_Utilities.getNavigationURLs("LoginPage")); return; }
    }

    for(let i=0; i<this.state.parserObject_transhistory.length; ++i){
      if(this.state.parserObject_transhistory[i].trans_id+""===event_trans_id){
        try {localStorage.setItem("parserObject_transhistorydetail",JSON.stringify(this.state.parserObject_transhistory[i])); }catch(err){;}
        break;
      }
    }
    //+++++++++++++
    //HistoryDetail
    //+++++++++++++
    history.push(wu_Utilities.getNavigationURLs("HistoryDetail"));
  }
  //----------------------------------------------------------------------------------------------------
  handleListItemClick_actions(event_trans_id){
    let methName = filename+"handleListItemClick_actions ";
    if(api.print_logs){console.log(methName+event_trans_id);}

    let isTransactionCompleted = true;
    let isTransactionPending   = true;
    let isTransactionCanceled  = true;
    for(let i=0; i<this.state.parserObject_transhistory.length; ++i){
      if(this.state.parserObject_transhistory[i].trans_id+""===event_trans_id){
        isTransactionCompleted = this.state.parserObject_transhistory[i].status==="COMPLETED" ? true : false;
        isTransactionPending   = this.state.parserObject_transhistory[i].status==="PENDING"   ? true : false;
        isTransactionCanceled  = this.state.parserObject_transhistory[i].status==="CANCELED"  ? true : false;
        //if(api.print_logs){console.log('this.state.parserObject_transhistory[i].status='+this.state.parserObject_transhistory[i].status);}
        try {localStorage.setItem("parserObject_transhistorydetail",JSON.stringify(this.state.parserObject_transhistory[i])); }catch(err){;}
        break;
      }
    }
    //nailed for testing:START---inactive
    //isTransactionPending = true;
    //nailed for testing:END
    this.setState({
      "actions_isOpen"       : true,
      "isTransactionCompleted" : isTransactionCompleted,
      "isTransactionPending"   : isTransactionPending,
      "isTransactionCanceled"  : isTransactionCanceled,
    });
  }
  //----------------------------------------------------------------------------------------------------
  //----------------------------------------------------------------------------------------------------
  get_date_FromObj(obj){
    if(obj && obj.date){
      return obj.date;
    }
    return " - ";
  }
  //----------------------------------------------------------------------------------------------------
  getTransferMethodFromObj(obj){
    if(obj && obj.typeId){
      if(obj.typeId===21){return this.NSInforString("TransferOnline_viewTM_lbl_BA_lb1");}
      else               {return this.NSInforString("TransferOnline_viewTM_lbl_CM_lb1");}
    }
    return " - ";
  }
  //----------------------------------------------------------------------------------------------------
  getStatusFromObj(obj){
    if(localStorage.getItem("lang")==='el'){
      if(obj && obj.statusEl){
        return obj.statusEl;
      }
    }
    else{
      if(obj && obj.statusEn){
        return obj.statusEn;
      }
    }
    return " - ";
  }
  //----------------------------------------------------------------------------------------------------
  get_statusColor_FromObj(obj){
    if(obj){
      if(obj.status === "COMPLETED"){ return "#35B6B4"; } //35B6B4 (green)
      if(obj.status === "CANCELED") { return "#F10D0D"; } //F10D0D (red)
      if(obj.status === "PENDING")  { return "#FF931E"; } //FF931E (orange)
    }
    return "#000000";
  }
  //----------------------------------------------------------------------------------------------------
  get_fullName_FromObj(obj){
    if(obj){
      return obj.rcv_fname + " " + wu_Utilities.addStars(obj.rcv_lname);
    }
    return " - ";
  }
  //----------------------------------------------------------------------------------------------------
  get_amount_FromObj(obj){
    if(obj && obj.totalAmount){
      return this.comvert2ProperAmountFormat(obj.totalAmount.toFixed(2));
    }
    return " - ";
  }
  //----------------------------------------------------------------------------------------------------
  get_countryName_FromObj(obj){
    if(obj && obj.country){
      return wu_Utilities.findCountryNameFromCountryId(obj.country,localStorage.getItem("lang"));
    }
    return " - ";
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Drop Down Listeners-------------------------------
  //----------------------------------------------------------------------------------------------------
  //...
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Button Listeners----------------------------------
  //----------------------------------------------------------------------------------------------------
  //...
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------TextField Listeners-------------------------------
  //----------------------------------------------------------------------------------------------------
  //...
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Utilities-----------------------------------------
  //----------------------------------------------------------------------------------------------------
  NSInforString = aKey => {
    if(localStorage.getItem("lang")==="en"){ return this.texts_en[aKey] ? this.texts_en[aKey] : ""; }
    else                                   { return this.texts_gr[aKey] ? this.texts_gr[aKey] : ""; }
  };
  //----------------------------------------------------------------------------------------------------
  verifyLength(value, length) {
    if (value && value.length >= length) { return true; }
    return false;
  }
  //----------------------------------------------------------------------------------------------------
  verifyGenericItem(key,val) {

    return false;
  }
  //----------------------------------------------------------------------------------------------------
  comvert2ProperAmountFormat(amountStr){
    try{
      let parts = amountStr.split('.');
      let part1 = this.numberWithCommas(parts[0]);
      let part2 = parts[1];
      return part1+","+part2;
    }catch(err){;}
    return amountStr;
  }
  numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------[goBack]------------------------------------------
  //----------------------------------------------------------------------------------------------------
  goBack(event) {

    if(localStorage.getItem("prev_view").trim()==="More"){
      history.goBack();
    }
    else{
      //+++++++++++++++
      //Goto Controller
      //+++++++++++++++
      history.push(wu_Utilities.getNavigationURLs("More"));
    }
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Popups--------------------------------------------
  //----------------------------------------------------------------------------------------------------
  dialog_handleOpen(dialog_msg){
    this.setState({
      "dialog_isOpen" : true,
      "dialog_msg"    : dialog_msg
    });
  }
  dialog_handleClose(){
    this.setState({ "dialog_isOpen": false });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Spinners------------------------------------------
  //----------------------------------------------------------------------------------------------------
  startSpinners(){
    this.setState({ "viewPleaseWait_hidden" : false });
  }
  //----------------------------------------------------------------------------------------------------
  stopSpinners(){
    this.setState({ "viewPleaseWait_hidden" : true });
  }
  //----------------------------------------------------------------------------------------------------
}
HistoryList.propTypes = {
  classes: PropTypes.object.isRequired
};
function mapStateToProps(state) {
  const { alert }    = state;
  const { dispatch } = state;
  return {
    dispatch,
    alert
  };
}
export default connect(mapStateToProps)(
  withStyles(HistoryListStyle)(HistoryList)
);
